<!-- components/Webinar.vue -->
 <!-- BR#112	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng-->
<template>
  <div
    v-if="visible"
   class="fixed inset-0 z-50 flex items-center justify-center bg-transparent"
  >
    <!-- Popup -->
    <div
      class="relative max-w-2xl w-full cursor-pointer rounded-lg overflow-hidden shadow-lg"
      @click="redirectToWebinar"
    >
      <!-- Close button -->
      <button
        @click="$emit('close')"
        class="absolute top-3 right-3 text-white bg-black bg-opacity-50 hover:bg-opacity-80 rounded-full p-2 z-10"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Image -->
      <img src="@/assets/webinar.png" alt="Webinar" class="w-full h-auto" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Webinar",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
    emits: ["close"],
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  }
  },

  methods: {
    redirectToWebinar() {
      window.open(
        "https://attendee.gotowebinar.com/register/4770258034732441429?source=icmaccess",
        "_blank"
      );
    },
    
  },

};
</script>

<style scoped>
/* Optional: smooth fade-in effect */
.fixed {
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
